module.exports = __webpack_public_path__ + "images/emoji/blossom.37b7de5eaf2656fafe76.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/blossom.png
// module id = 9Gip
// module chunks = 2